"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var TenderIcon_1 = __importDefault(require("../../../Icons/Notifications/TenderIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "If think you can tackle this solution, propose a Project and get funding from the DAO",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "here"),
            ".")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The Tender \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\" can now receive Bid Projects")); }
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Si crees que puedes abordar esta soluci\u00F3n, prop\u00F3n un proyecto y obt\u00E9n financiaci\u00F3n del DAO",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "aqu\u00ED"),
            ".")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "La Licitaci\u00F3n \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\" ahora puede recibir Proyectos de Oferta")); }
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u5982\u679C\u4F60\u8BA4\u4E3A\u53EF\u4EE5\u89E3\u51B3\u8FD9\u4E2A\u95EE\u9898\uFF0C\u63D0\u51FA\u4E00\u4E2A\u9879\u76EE\u5E76\u4ECEDAO\u83B7\u5F97\u8D44\u91D1\u652F\u6301",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u8FD9\u91CC"),
            ".")); },
        title: function (proposalTitle) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u6295\u6807 \"",
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, proposalTitle),
            "\" \u73B0\u5728\u53EF\u4EE5\u63A5\u6536\u9879\u76EE\u6295\u6807")); }
    }
};
var GovernanceTenderPassedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(TenderIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title(notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceTenderPassedNotification;
